// the progressions: a theme is an ordered list of level paths, or {wanted, acquired, language}
// (acquired levels and their dependencies are skipped). Chosen with the url param `theme`.

const themes = {

    '2D_distance': [
        'levels_maths/black_box_simple',
        'levels_maths/2D_distance_between_points'
    ],

    dot_product: [
        'levels_maths/black_box_simple',
        'levels_maths/xy_coords', //FIXME
        'levels_maths/dot_product_geo',
        'levels_maths/dot_product_formula'
    ],

    ratio: [
        'levels_maths/black_box_short',
        'levels_maths/proportionality_geometric'
    ],


    base_number_system: [
        'levels_maths/black_box_simple',
        'levels_maths/int_squared', //FIXME
        'levels_maths/base_numeric_with_square'
    ],


    test: [
        'levels_maths/formula/test_formula',
        'levels/example_bad_choices',
        'levels/example_emoticons'
    ],

    basic_coding: [
        'levels/string_or_integers',
        'levels/overriding_vars',
        'levels/functions',
        'levels/length',
        'levels/arrays_position',
        'levels/booleans',
        'levels/test_or_affectation',
        'levels/conditions2',
        'levels/advanced_functions',
        'levels/composed_functions'
    ],


    basic_python: {
        wanted: [
            'levels/variables',
            'levels/string_or_integers',
            'levels/overriding_vars',
            'levels/functions',
            'levels/length',
            'levels/arrays_position',
            'levels/booleans',
            'levels/test_or_affectation',
            'levels/conditions2',
            'levels/advanced_functions',
            'levels/composed_functions'
        ],
        language: 'python'
    },

    explorer_basic: [
        'levels/string_or_integers',
        'levels/overriding_vars'
    ],



    explorer_conditions: {
        wanted: [
            'levels/booleans',
            'levels/conditions2'
        ],
        acquired: [
            'levels/string_or_integers',
            'levels/overriding_vars'
        ]
    },


    explorer_functions_1: {
        wanted: [
            'levels/functions'
        ],
        acquired: [
            'levels/_easy_maths',
            'levels/variables'
        ]
    },


    explorer_functions_2: {
        wanted: [
            'levels/advanced_functions',
            'levels/composed_functions'
        ],
        acquired: [
            'levels/string_or_integers',
            'levels/overriding_vars',
            'levels/functions',
            'levels/conditions2'
        ]
    },


    explorer_functions_3: {
        wanted: [
            'levels/functions_as_vars',
            'levels/functions_as_params2'
        ],
        acquired: [
            'levels/string_or_integers',
            'levels/overriding_vars',
            'levels/functions',
            'levels/conditions2',
            'levels/advanced_functions',
            'levels/composed_functions'
        ]
    },

    explorer_array: {
        wanted: [
            'levels/arrays_position',
            'levels/arrays_position2',
            'levels/arrays_setter'
        ],
        acquired: [
            'levels/string_or_integers',
            'levels/overriding_vars',
            'levels/functions',
            'levels/length',
            'levels/booleans',
            'levels/test_or_affectation',
            'levels/conditions2',
            'levels/advanced_functions',
            'levels/composed_functions'
        ]
    },

    explorer_iterator: {
        wanted: [
            'levels/for_simple'
        ],
        acquired: [
            'levels/string_or_integers',
            'levels/overriding_vars',
            'levels/functions',
            'levels/length',
            'levels/booleans',
            'levels/test_or_affectation',
            'levels/conditions2',
            'levels/advanced_functions',
            'levels/composed_functions'
        ]
    },

    explorer_object: {
        wanted: [
            'levels/object_simple'
        ],
        acquired: [
            'levels/string_or_integers',
            'levels/overriding_vars',
            'levels/functions',
            'levels/length',
            'levels/booleans',
            'levels/test_or_affectation',
            'levels/conditions2',
            'levels/advanced_functions',
            'levels/composed_functions'
        ]
    },


    ngrams: {
        wanted: [
            'levels/ngrams_count_23'
        ],
        acquired: []
    },



    // FIXME: handle level dependencies with url param "challenge"
    power: [
        'levels_maths/black_box_simple',
        'levels_maths/berengere_maths/power_square',
        'levels_maths/berengere_maths/signs_rule_simple',
        'levels_maths/berengere_maths/signs_rule',
        'levels_maths/berengere_maths/power_signs_rule',
        'levels_maths/berengere_maths/power_one',
        'levels_maths/berengere_maths/power_multiplication_positive',
        'levels_maths/berengere_maths/positives_negatives_additions',
        'levels_maths/berengere_maths/power_zero',
        'levels_maths/berengere_maths/power_multiplication_negative'
    ]

}


export default themes
